import { types } from '../types/types';

const initialState = {
    usuarios:         null,
    municipios:       null,
    usuarisMunicipi:  null,
    munCreado:        null,
};

export const adminReducer = (state = initialState, action) => {
    switch (action.type) {

        case types.adminCarregarUsuaris:
            return { ...state, usuarios: action.payload };

        case types.adminCarregarMunicipis:
            return { ...state, municipios: action.payload };

        case types.adminCarregarUsuarisMunicipi:
            return { ...state, usuarisMunicipi: action.contingut  };

        case types.adminCrearMunicipi:
            return { ...state, munCreado: { IdMunicipio: action.IdMunicipio } };

        default:
            return state;
    }
};